import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './FilterPanel.css';

import { QUEUE_DATE_FORMAT } from '../../constants/onboardingQueue';

const OnboardingQueueFilterPanel = ({
  searchValue,
  from,
  to,
  dateLabel,
  onSearchChange,
  onFromChange,
  onToChange,
  onSubmit,
  onClear,
}) => (
  <Form onSubmit={onSubmit} data-testid='queue-filter-panel'>
    <Form.Group className='onboarding-queue-filters'>
      <Form.Field className='onboarding-queue-search-field'>
        <label htmlFor='queueSearch'>Search</label>
        <input
          id='queueSearch'
          name='queueSearch'
          data-testid='queue-filter-search'
          placeholder='Offer id, account number or customer name'
          value={searchValue}
          onChange={event => onSearchChange(event.target.value)}
        />
      </Form.Field>
      <Form.Field className='onboarding-queue-date-field'>
        <label htmlFor='queueFrom' data-testid='queue-filter-from-label'>
          {`${dateLabel} From`}
        </label>
        <DatePicker
          id='queueFrom'
          name='queueFrom'
          selected={from}
          onChange={onFromChange}
          dateFormat={QUEUE_DATE_FORMAT}
          selectsStart
          startDate={from}
          endDate={to}
          maxDate={to}
          isClearable
        />
      </Form.Field>
      <Form.Field className='onboarding-queue-date-field'>
        <label htmlFor='queueTo' data-testid='queue-filter-to-label'>
          {`${dateLabel} To`}
        </label>
        <DatePicker
          id='queueTo'
          name='queueTo'
          selected={to}
          onChange={onToChange}
          dateFormat={QUEUE_DATE_FORMAT}
          selectsEnd
          startDate={from}
          endDate={to}
          minDate={from}
          isClearable
        />
      </Form.Field>
      <Form.Field className='onboarding-queue-actions-field'>
        <label htmlFor='queueSearchButton'>Actions</label>
        <Button
          color='green'
          id='queueSearchButton'
          data-testid='queue-filter-submit'
          inverted
        >
          Search
        </Button>
        <Button
          color='green'
          type='button'
          data-testid='queue-filter-clear'
          onClick={onClear}
          inverted
        >
          Clear
        </Button>
      </Form.Field>
    </Form.Group>
  </Form>
);

OnboardingQueueFilterPanel.propTypes = {
  searchValue: PropTypes.string,
  from: PropTypes.object,
  to: PropTypes.object,
  dateLabel: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onFromChange: PropTypes.func.isRequired,
  onToChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

OnboardingQueueFilterPanel.defaultProps = {
  searchValue: '',
  from: null,
  to: null,
};

export default OnboardingQueueFilterPanel;
